/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_TitleInputs */

const cs_templates_ai_title = /** @type {(inputs: Templates_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI asistent`)
};

const en_templates_ai_title = /** @type {(inputs: Templates_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI assist`)
};

/**
* | output |
* | --- |
* | "AI assist" |
*
* @param {Templates_Ai_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_title = /** @type {((inputs?: Templates_Ai_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_title(inputs)
	return cs_templates_ai_title(inputs)
});